'use client';

import { useContext } from 'react';

import {
  SubscribeModalContext,
  type SubscribeModalContextValue,
} from './context';

/**
 * The in-place subscribe modal launcher, or `null` when no
 * {@link SubscribeModalProvider} is mounted. Nullable by design: bio surfaces
 * subscribe via the route (no provider), and only the non-1:1 DM inbox mounts
 * one — a consumer that needs it (a post card with no `bioContext`) checks for
 * `null` and treats its absence as a wiring bug.
 */
export function useSubscribeModal(): SubscribeModalContextValue | null {
  return useContext(SubscribeModalContext);
}
